"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathTmp = void 0;
const utils_1 = require("./utils");
const Vector3_1 = require("./Vector3");
const Quaternion_1 = require("./Quaternion");
const Matrix_1 = require("./Matrix");
// Temporary pre-allocated objects for engine internal use
// usage in any internal function :
// var tmp = Tmp.Vector3[0];   <= gets access to the first pre-created Vector3
// There's a Tmp array per object type : int, float, Vector2, Vector3, Vector4, Quaternion, Matrix
/**
 * @public
 * Same as Tmp but not exported to keep it only for math functions to avoid conflicts
 */
exports.MathTmp = {
    Vector3: (0, utils_1.buildArray)(6, Vector3_1.Vector3.Zero),
    Matrix: (0, utils_1.buildArray)(2, Matrix_1.Matrix.Identity),
    Quaternion: (0, utils_1.buildArray)(3, Quaternion_1.Quaternion.Zero),
    staticUp: Vector3_1.Vector3.Up(),
    tmpMatrix: Matrix_1.Matrix.Zero()
};
//# sourceMappingURL=preallocatedVariables.js.map